kv.controller('contractEditCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
    var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
    vm.primaryKey = 'contract_id';
    vm.entity = 'contract';
    vm.rest = vm.getInjection('resource').init(vm.entity);
    vm.validator = vm.getInjection('validator');

    // let cmdate = vm.getInjection('cmdate');

    var REST = resource.init(vm.entity);
    let url_segments = window.location.pathname.split( '/' );
    let page_entity_id = url_segments[2];
    let page_identifier = url_segments[3];

    if(page_identifier == 'edit') {
        $http.get("/contract/" + page_entity_id).then(function(response) {
            vm.data = response.data;
            if (vm.data.fees) {
                angular.forEach(vm.data.fees, function (v, i) {
                    vm.data.fees[i].id = v.fee_type_id;
                    vm.data.fees[i].name = v.fee_type_name;
                });
            }
            if(vm.data.parent_id){
                vm.data.contract_number = vm.data.parent.number;
            }
        });

    } else {
        vm.data = {};
        vm.isNewRecord = true;

        // $http.get("/document_series").then(function(response) {
        //     if(response !== undefined && response.data !== undefined && response.data.data !== undefined ) {
        //         var result = response.data.data;
        //         angular.forEach(result, function (v, i) {
        //             if( result[i].series_type_id === 1 && result[i].is_active === 1){
        //                 result.prefix = v.prefix;
        //                 result.current_number = v.current_number;
        //                 result.end_number = v.end_number;
        //                 result.suffix = v.suffix;
        //             }
        //         });
        //         vm.data.series = result.prefix;
        //         vm.data.suffix = result.suffix;
        //         vm.data.end_number = result.end_number;
        //         vm.current_number = result.current_number;
        //         vm.data.serial_number = result.current_number;
        //
        //         if(vm.data.suffix != null){
        //             vm.data.contract_series_type = result.prefix.concat(result.current_number, result.suffix);
        //         }else if(vm.data.prefix != null){
        //             vm.data.contract_series_type = result.prefix.concat(result.current_number);
        //         }else{
        //             vm.data.contract_series_type = result.current_number;
        //         }
        //
        //
        //     }
        // });
        //
        //
        // $scope.$watch("vm.data.contract_series_type", function (value) {
        //     if (value){
        //         $http.get("/document_series").then(function(response) {
        //             if(response !== undefined && response.data !== undefined && response.data.data !== undefined ) {
        //                 var result = response.data.data;
        //
        //                 angular.forEach(result, function (v, i) {
        //                     if (result[i].prefix != null){
        //                         if(result[i].series_type_id === 1 && result[i].is_active === 1 && (result[i].document_series_id == value || result[i].prefix.concat(result[i].current_number) == value || result[i].current_number == value || result[i].prefix.concat(result[i].current_number, result[i].suffix) == value)){
        //                             result.prefix = v.prefix;
        //                             result.current_number = v.current_number;
        //                             result.end_number = v.end_number;
        //                             result.suffix = v.suffix;
        //                         }
        //                     }else if (result[i].current_number == value){
        //                         result.prefix = v.prefix;
        //                         result.current_number = v.current_number;
        //                         result.end_number = v.end_number;
        //                         result.suffix = v.suffix;
        //                     }
        //                 });
        //                 vm.data.series = result.prefix;
        //                 vm.data.serial_number = result.current_number;
        //                 vm.data.end_number = result.end_number;
        //                 vm.current_number = result.current_number;
        //                 vm.data.suffix = result.suffix;
        //                 vm.data.prefix = result.prefix;
        //                 if(vm.data.suffix != null){
        //                     vm.data.contract_series_type = result.prefix.concat(result.current_number, result.suffix);
        //                 }else if(vm.data.prefix != null){
        //                     vm.data.contract_series_type = result.prefix.concat(result.current_number);
        //                 }else{
        //                     vm.data.contract_series_type = result.current_number;
        //                 }
        //
        //
        //             }
        //         });
        //     }
        // }, true);
        //
        //
        // $scope.$watch('vm.data.series', function (value) {
        //     if (value && vm.data.serial_number && vm.data.serial_number !== null && vm.data.suffix) {
        //         vm.data.number = vm.data.series.concat(vm.data.serial_number, vm.data.suffix);
        //     }else if(value && vm.data.serial_number && vm.data.serial_number !== null){
        //         vm.data.number = vm.data.series.concat(vm.data.serial_number);
        //     }
        // });
        //
        // $scope.$watch('vm.data.serial_number', function (value) {
        //     if (value && vm.data.series && vm.data.series !== null && vm.data.suffix) {
        //         vm.data.number = vm.data.series.concat(vm.data.serial_number, vm.data.suffix);
        //     }else if(value && vm.data.series && vm.data.series !== null){
        //         vm.data.number = vm.data.series.concat(vm.data.serial_number);
        //     }else{
        //         vm.data.number = vm.data.serial_number;
        //     }
        // });

        let defaultObjects = JSON.parse($element.find("#defaultObjects").attr("defaultObjects"));
        vm.data = defaultObjects;
        vm.data.series = vm.bladeParams.series ? vm.bladeParams.series : vm.data.series;
        vm.data.numbering_option = 'automatic';
    }

    vm.checkContractNumber = function () {
        REST.get({
            url: "contract/list",
            params: {
                contract_number: vm.data.number
            }
        }).then(function (data) {
            if (data && data.length >= 1) {
                vm.data.has_duplicated_contract_number = true;
            }else{
                vm.data.has_duplicated_contract_number = false;
            }

        });
    }

    vm.newEntity = function newEntity(entity) {
        if(!vm.data) {
            vm.data = {};
        }

        if(!vm.data[entity]) {
            return vm.data[entity] = [{}];
        }

        return vm.data[entity].push({});
    };



    vm.deleteEntity = function deleteEntity($index, entity, id) {
        if(!id) {
            return vm.data[entity].splice($index,1);
        }
        
        if(page_entity_id) {
            REST.delete({
                url: vm.entity + '/:id/' + entity + '/:entityId',
                params: {
                    id: page_entity_id,
                    entityId: id
                }
            }).then(function(data) {
                vm.data[entity].splice($index,1);
            });
        }
    };

    vm.quickAddCustomer = function quickAddCustomer() {
        vm.openModal({
            animation: true,
            component: 'quickAddEntity',
            resolve: {
                entity: function () {
                    return $rootScope.quickAddEntityTemplate = 'customer';
                }
            }
        }).then(function (data) {
            vm.data.customer_id = data.customer_id;
            vm.data.customer = {
                customer_name: data.customer_name
            };
        });
    };

    vm.validateSomeInputs = function () {
        vm.checkContractNumber();

        vm.custom_errors = null;
        vm.has_error = false;


        if(vm.data.contract_series_type && vm.data.serial_number > vm.data.end_number){
            $('[ng-model="vm.data.serial_number"] .select2-selection--single').css("border", "1px solid red");
            if (!vm.custom_errors) vm.custom_errors = [];
            vm.custom_errors.push(vm.trans('LANG.NO_AVAILABLE_CONTRACT_SERIES'));
            vm.has_error = true;
        } else {
            $('[ng-model="vm.data.serial_number"] .select2-selection--single').css("border", "1px solid #c2cad8");
        }

        if(vm.data.numbering_option == 'automatic' && !vm.data.document_series_id){
            $('[ng-model="vm.data.document_series_id"] .select2-selection--single').css("border", "1px solid red");
            if (!vm.custom_errors) vm.custom_errors = [];
            vm.custom_errors.push(vm.trans('LANG.DOCUMENT_SERIES') + ' ' + vm.trans('IS_REQUIRED'));
            vm.has_error = true;
        } else {
            $('[ng-model="vm.data.document_series_id"] .select2-selection--single').css("border", "1px solid #c2cad8");
        }

        if(vm.data.has_duplicated_contract_number){
            $('[ng-model="vm.data.number"] .select2-selection--single').css("border", "1px solid red");
            if (!vm.custom_errors) vm.custom_errors = [];
            vm.custom_errors.push(vm.trans('LANG.DUPLICATED_CONTRACT_NUMBER'));
            vm.has_error = true;
        } else {
            $('[ng-model="vm.data.number"] .select2-selection--single').css("border", "1px solid #c2cad8");
        }

        // gbarcun comentat la cererea NNDKP: 4 feb 2026
        // if(!vm.data.contract_id && vm.bladeParams.contractfromempowerment == 1 && vm.data.contract_type_id == 'CONTRACT'){
        //     if (!vm.custom_errors) vm.custom_errors = [];
        //     vm.custom_errors.push(vm.trans('LANG.CONTRACT_FROM_EMPOWERMENT_WARNING'));
        //     vm.has_error = true;
        // }

        if(vm.has_error){
            $('.custom_error_messages').css('display', 'block');
        } else {
            $('.custom_error_messages').css('display', 'none');

            // let postData = vm.prepareDataToSave();
            // if (postData.contract_id) {
            //     REST.put({
            //         url: "contract/" + postData.contract_id,
            //         data: postData
            //     }).then((response) => {
            //         if (response.status == true) {
            //             toastr.success(vm.trans('LANG.OPERATION_SUCCESSFULLY'), {timeOut: 2000});
            //         } else {
            //             vm.alert('ALERT', vm.trans(response.data.error));
            //         }
            //     });
            // } else {
            //     REST.post({
            //         url: "contract/",
            //         data: postData
            //     }).then((response) => {
            //         if (response.status == true) {
            //             toastr.success(vm.trans('LANG.OPERATION_SUCCESSFULLY'), {timeOut: 2000});
            //         } else {
            //             vm.alert('ALERT', vm.trans(response.data.error));
            //         }
            //     });
            // }
            vm.save();
        }

    };

    vm.prepareDataToSave = function () {
        let postData = angular.copy(vm.data);
        // used for validations: if contract is normal created, do validations, else not (case project, where required data is sent from backend)
        postData.basic_create = true;
        // unset unneeded data:
        // customer_id, tenant_id, customer object, customer_fiscal_entity, sys_contract_status,
        // tenant_fiscal_entity, responsible, source_user, created_by, projects, parent
        postData.customer_name = undefined;
        postData.tenant_id = undefined;
        postData.customer = undefined;
        postData.customer_fiscal_entity = undefined;
        postData.sys_contract_status = undefined;
        postData.tenant_fiscal_entity = undefined;
        postData.responsible = undefined;
        postData.source_user = undefined;
        postData.created_by = undefined;
        postData.projects = undefined;
        postData.parent = undefined;

        // if numbering option is manual, send the number field & reset the series_id
        if (postData.numbering_option === 'manual' && postData.number !== undefined && postData.number !== '') {
            postData.document_series_id = undefined;
            postData.document_series = undefined;
        } else if (postData.numbering_option === 'automatic') {
            // if numbering option is automatic, send the document_series_id field & reset the number field
            postData.number = null;
        }
        return postData;
    };

	return vm;
});
